import {
  IShipmentReferenceNumber,
  ReferenceNumberType,
} from '@rygen/rygen-ui/model';

export class BillingShipmentReferenceNumber implements IShipmentReferenceNumber {
  type?: ReferenceNumberType;
  value?: string;

  constructor(opts?: Partial<BillingShipmentReferenceNumber>) {
    if (opts?.type != null) {
      this.type = new ReferenceNumberType(opts?.type);
    }
    if (opts?.value != null) {
      this.value = opts.value;
    }
  }
}
